import { GIFTS_OFFER_PERCENTAGE_DISCOUNT } from "src/data/app-constants";

export default function getProductOfferDiscountedPrice(price) {
  return price - price * GIFTS_OFFER_PERCENTAGE_DISCOUNT;
}
